import { useState } from "react";

const benefits = [
  {
    icon: "01",
    title: "Learn by building",
    text: "Work on practical products and solve the kind of challenges that sharpen your development skills."
  },
  {
    icon: "02",
    title: "Mentorship that matters",
    text: "Get thoughtful guidance, regular feedback and the space to ask questions as you grow."
  },
  {
    icon: "03",
    title: "Modern tech stack",
    text: "Build with relevant tools and workflows while learning how strong software teams ship quality work."
  }
];

const steps = [
  ["01", "Apply online", "Share your resume and a short introduction."],
  ["02", "Intro conversation", "We learn about your interests, skills and goals."],
  ["03", "Skill discussion", "Meet the team and talk through your approach."],
  ["04", "Start your journey", "Join KPL Infotech and begin building with us."]
];

export default function Career() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });
  const [resume, setResume] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value
    });
  };

  const handleFileChange = (event) => {
    setResume(event.target.files[0] || null);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    const data = new FormData();
    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    data.append("message", formData.message);
    data.append("role", "React Developer Intern");
    data.append("resume", resume);

    try {
      const response = await fetch("http://localhost:5000/send-career", {
        method: "POST",
        body: data
      });
      const result = await response.json();

      alert(result.message);
      setFormData({ name: "", email: "", phone: "", message: "" });
      setResume(null);
      event.target.reset();
    } catch (error) {
      console.log(error);
      alert("Something went wrong");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="career-page">
      <section className="career-hero">
        <div className="career-hero-content">
          <span className="career-eyebrow">Careers at KPL Infotech</span>
          <h1>Build your future while building what matters.</h1>
          <p>
            Join a team where curiosity is valued, ideas are heard and every
            project is an opportunity to create meaningful digital solutions.
          </p>
          <div className="career-hero-actions">
            <a className="career-primary-btn" href="#open-positions">View open roles</a>
            <a className="career-text-link" href="#life-at-kpl">Why join us <span aria-hidden="true">-&gt;</span></a>
          </div>
          <div className="career-stats" aria-label="Career highlights">
            <div><strong>3+</strong><span>Service areas</span></div>
            <div><strong>1:1</strong><span>Mentorship support</span></div>
            <div><strong>100%</strong><span>Hands-on learning</span></div>
          </div>
        </div>

        <div className="career-hero-panel" aria-label="Our workplace values">
          <div className="career-panel-glow"></div>
          <div className="career-panel-top">
            <span>Life at KPL</span>
            <span className="career-status-dot">Growing team</span>
          </div>
          <div className="career-panel-copy">
            <span className="career-panel-mark">K</span>
            <h2>Small team.<br />Big learning.</h2>
            <p>Collaboration, mentorship and real-world experience from day one.</p>
          </div>
          <div className="career-panel-tags">
            <span>Learn</span>
            <span>Build</span>
            <span>Grow</span>
          </div>
        </div>
      </section>

      <section className="career-benefits" id="life-at-kpl">
        <div className="career-section-heading">
          <span className="career-eyebrow">Why KPL Infotech</span>
          <h2>A place to do meaningful work and keep growing.</h2>
          <p>We create an environment where early-career talent can learn with confidence and contribute with purpose.</p>
        </div>
        <div className="career-benefit-grid">
          {benefits.map((benefit) => (
            <article className="career-benefit-card" key={benefit.title}>
              <span className="career-card-number">{benefit.icon}</span>
              <h3>{benefit.title}</h3>
              <p>{benefit.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="career-openings" id="open-positions">
        <div className="career-section-heading career-section-heading-left">
          <span className="career-eyebrow">Open positions</span>
          <h2>Find the role that moves you forward.</h2>
          <p>We are looking for thoughtful people who enjoy learning, building and solving real problems.</p>
        </div>

        <article className="career-role-card">
          <div className="career-role-main">
            <div className="career-role-icon">&lt;/&gt;</div>
            <div>
              <div className="career-role-label">Engineering</div>
              <h3>React Developer Intern</h3>
              <p>Build responsive web experiences, strengthen your frontend fundamentals and contribute to live projects with our team.</p>
              <div className="career-role-tags">
                <span>Internship</span>
                <span>Frontend</span>
                <span>Delhi, India</span>
              </div>
            </div>
          </div>
          <a className="career-role-apply" href="#apply-now">Apply now <span aria-hidden="true">-&gt;</span></a>
        </article>
      </section>

      <section className="career-process">
        <div className="career-section-heading">
          <span className="career-eyebrow">What to expect</span>
          <h2>A simple, human hiring process.</h2>
        </div>
        <div className="career-process-grid">
          {steps.map(([number, title, text]) => (
            <article className="career-process-step" key={title}>
              <span>{number}</span>
              <h3>{title}</h3>
              <p>{text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="career-application" id="apply-now">
        <div className="career-application-copy">
          <span className="career-eyebrow">Apply today</span>
          <h2>Take the next step in your career.</h2>
          <p>Tell us a little about yourself and attach your resume. We will review your application and reach out if your profile is a fit.</p>
          <div className="career-application-note">
            <strong>Applying for</strong>
            <span>React Developer Intern</span>
          </div>
        </div>

        <form className="career-form" onSubmit={handleSubmit}>
          <div className="career-form-row">
            <label>
              Full name
              <input type="text" name="name" placeholder="Your name" value={formData.name} onChange={handleChange} required />
            </label>
            <label>
              Email address
              <input type="email" name="email" placeholder="you@example.com" value={formData.email} onChange={handleChange} required />
            </label>
          </div>
          <label>
            Phone number
            <input type="tel" name="phone" placeholder="+91 98765 43210" value={formData.phone} onChange={handleChange} />
          </label>
          <label>
            Resume
            <input type="file" name="resume" accept=".pdf,.doc,.docx" onChange={handleFileChange} required />
            <small>PDF, DOC or DOCX format</small>
          </label>
          <label>
            Short introduction
            <textarea name="message" placeholder="Tell us about your skills, interests and what you would like to learn..." value={formData.message} onChange={handleChange} />
          </label>
          <button className="career-submit-btn" type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit application"}
          </button>
        </form>
      </section>
    </main>
  );
}
